import { useTranslation } from "react-i18next";

const OfflineUI = () => {
  const {t, i18n} = useTranslation();
    const reload = () => {
        window.location.reload();
    }
  return (
    <div className="h-screen w-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <h1 className="text-3xl font-bold text-red-600">{t('NetworkStatus.OfflineUi')}</h1>
        <p className="text-gray-700 mt-2">{t('NetworkStatus.OfflineUiMsg')}</p>
        <button onClick={reload} className="mt-2">{t('NetworkStatus.Reload')}</button>
      </div>
    </div>
  );
};

export default OfflineUI;